import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const ProjectsManagement = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const projectsManagementModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/project-management',
    name: 'project-management',
    component: ProjectsManagement,
    meta: {
      title: 'Gestión de proyectos',
      auth: {
        roles: [ADMIN],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
